module.exports = __webpack_public_path__ + "static/media/aierkang1.8cb1fb5a.png";